module.exports = __webpack_public_path__ + "media/images/create-7124dc55371e8a302b24dea221770d0c.svg";